/*
  Category tabs on mood pages (sections/mm-collection-grid.liquid, "Category tabs").

  Each tab is a normal link to the mood filtered by tags (/collections/curator/apparel+women), so it works
  without this script and can be shared. With the script, a tap fetches only the grid section through the
  Section Rendering API, swaps it in place and updates the address bar, so the banner and the look row stay
  put and the page does not jump. Back and forward re-render the grid for the address shown.

  A chosen sort order (other than the mood's own order) is kept when switching tabs; filters are cleared, because they belong to the category
  that was open.

  On page 2 and later the server cannot count the tabs (see the section), so the nav arrives with
  data-mm-tabs-pending and is filled in here from page 1.
*/
(function () {
  if (window.mmMoodTabsReady) return;
  window.mmMoodTabsReady = true;

  function wrapFor(id) {
    return document.getElementById('shopify-section-' + id);
  }

  function withSort(href, nav) {
    var url = new URL(href, window.location.origin);
    var sort = new URLSearchParams(window.location.search).get('sort_by');
    if (sort && sort !== nav.dataset.defaultSort) url.searchParams.set('sort_by', sort);
    return url.pathname + url.search;
  }

  function sectionUrl(path, id) {
    var url = new URL(path, window.location.origin);
    url.searchParams.set('section_id', id);
    return url.pathname + url.search;
  }

  function fetchSection(path, id) {
    return fetch(sectionUrl(path, id), { headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id);
        if (!fresh) throw new Error('no section');
        return fresh;
      });
  }

  /* A soft fade on the right edge while more tabs sit off screen. */
  function edge(nav) {
    if (!nav) return;
    nav.classList.toggle('has-more', nav.scrollLeft + nav.clientWidth < nav.scrollWidth - 4);
  }

  document.addEventListener('scroll', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-mm-tabs]')) edge(event.target);
  }, true);

  window.addEventListener('resize', function () {
    edge(document.querySelector('[data-mm-tabs]'));
  });

  /* Keep the open tab in view inside the scrolling row, without moving the page. */
  function revealActive(nav) {
    if (!nav) return;
    edge(nav);
    var active = nav.querySelector('.mm-tabs__tab.is-active');
    if (!active) return;
    var box = nav.getBoundingClientRect();
    var tab = active.getBoundingClientRect();
    if (tab.left < box.left || tab.right > box.right) {
      nav.scrollLeft += tab.left - box.left - (box.width - tab.width) / 2;
    }
    edge(nav);
  }

  function syncFacets() {
    /* facets.js keeps its own idea of the current query; line it up with the new address. */
    if (window.FacetFiltersForm) {
      window.FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
      window.FacetFiltersForm.filterData = [];
    }
  }

  var busy = false;
  /* The address the grid currently shows. Type tabs change only the query (?filter.p.product_type=...), so Back and
     Forward compare the full address, not just the path. */
  var shown = window.location.pathname + window.location.search;

  function load(path, id, push) {
    var wrap = wrapFor(id);
    if (!wrap || busy) {
      if (!wrap) window.location.href = path;
      return;
    }
    busy = true;
    var grid = wrap.querySelector('.mm-cgrid');
    if (grid) {
      grid.classList.add('is-switching');
      grid.setAttribute('aria-busy', 'true');
    }
    fetchSection(path, id)
      .then(function (fresh) {
        if (push) history.pushState({ mmTabs: id, searchParams: new URL(path, window.location.origin).search.slice(1) }, '', path);
        shown = path;
        wrap.innerHTML = fresh.innerHTML;
        syncFacets();
        var nav = wrap.querySelector('[data-mm-tabs]');
        revealActive(nav);
        var top = nav ? nav.getBoundingClientRect().top : 0;
        if (nav && top < 0) {
          window.scrollBy({ top: top - 110, behavior: 'smooth' });
        }
        var current = nav && nav.querySelector('.mm-tabs__tab.is-active');
        if (current && push) current.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('mm:tabs:changed', { detail: { path: path } }));
      })
      .catch(function () {
        window.location.href = path;
      })
      .then(function () {
        busy = false;
        var g = wrapFor(id) && wrapFor(id).querySelector('.mm-cgrid');
        if (g) {
          g.classList.remove('is-switching');
          g.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-mm-tab]');
    if (!link) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    var nav = link.closest('[data-mm-tabs]');
    if (!nav || !window.fetch || !window.history.pushState) return;
    event.preventDefault();
    if (link.classList.contains('is-active') && !window.location.search) return;
    load(withSort(link.getAttribute('href'), nav), nav.dataset.sectionId, true);
  });

  window.addEventListener('popstate', function () {
    var nav = document.querySelector('[data-mm-tabs]');
    if (!nav) return;
    var now = window.location.pathname + window.location.search;
    if (now === shown) return;
    shown = now;
    load(now, nav.dataset.sectionId, false);
  });

  function fillPending() {
    var nav = document.querySelector('[data-mm-tabs][data-mm-tabs-pending]');
    if (!nav) return;
    var id = nav.dataset.sectionId;
    fetchSection(nav.dataset.path, id)
      .then(function (fresh) {
        var freshNav = fresh.querySelector('[data-mm-tabs]');
        if (freshNav && !freshNav.hasAttribute('data-mm-tabs-pending')) {
          nav.replaceWith(freshNav);
          revealActive(freshNav);
        }
      })
      .catch(function () {});
  }

  function init() {
    revealActive(document.querySelector('[data-mm-tabs]'));
    fillPending();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
